import script from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./PhoneInput.vue?vue&type=script&setup=true&lang=js"

import "./PhoneInput.vue?vue&type=style&index=0&id=2f7598ef&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f7598ef"]])

export default __exports__